import React from 'react';

var MiscueSessionsStore = require('../store/miscueSessionStore');


exports.LearnerYearGroupDropDown = React.createClass({

  propTypes: {
    emptyValue: React.PropTypes.node,
    placeholder: React.PropTypes.string,
    onSelect: React.PropTypes.func
  },

  value: null,

  render(){
    var yearGroups = MiscueSessionsStore.getMiscueYearGroups();
    this.value = this.props.value || this.props.defaultValue;
    var {emptyValue, placeholder} = this.props;

    var props = _.assign({}, this.props);
    delete props.emptyValue;
    delete props.onSelect;

    var className = props.className || "";

    className += " form-control";

    return (
      <select {...props} onChange={this.onChange} ref="SelectControl"
                         className={className}>
        {placeholder && <option value="" disabled selected hidden>{placeholder}</option>}
        {emptyValue && <option value="">{emptyValue}</option> }
        {yearGroups.map(
          (yearGroup, index) => (
            <option key={index} value={yearGroup.id}>{yearGroup.title}</option>)
        )}
      </select>
    )
  },

  onChange(e){
    var {onChange, onSelect} = this.props;
    this.value = this.refs["SelectControl"].value;
    if (typeof onChange === "function") {
      onChange.apply(this, arguments);
    }

    if (typeof onSelect === "function") {
      onSelect(this.value);
    }
  }

});

exports.LearnerYearGroupText = function (yearGroupId) {
  return MiscueSessionsStore.getMiscueYearGroup(yearGroupId).title || "";
};
